

import {Tools} from '@helpers/tools';
import {extend} from 'vee-validate/dist/vee-validate.full.esm';

extend('int', v => Tools.isNumeric(Tools.fromArabicNumber(v)));

extend('mobile', v => Tools.isKsaMobile(v));

extend('identity', v => {
  if (v === null || v === undefined || v === '') {
    return true;
  }
  const s = String(Tools.fromArabicNumber(v) ?? '').trim();
  return s === '0' || /^\d{10}$/.test(s);
});

export default extend;
